import React from "react";

const ReturnRefundPolicy = () => {
  return (
    <div className="min-h-screen bg-slate-50 px-4 py-10">
      <div className="max-w-3xl mx-auto bg-white shadow-lg rounded-2xl px-6 py-8 md:px-10 md:py-12">
        {/* Header */}
        <header className="mb-8 text-center">
          <h1 className="text-2xl md:text-3xl font-bold text-slate-900 mb-2">
            Return &amp; Refund Policy – TAMILSANDHAI RETAILERS
          </h1>
          <p className="text-sm md:text-base text-slate-600">
            Thank you for shopping with TAMILSANDHAI RETAILERS. Please read our Return &amp; Refund
            Policy carefully before making a purchase.
          </p>
        </header>

        {/* 1. No Return / No Exchange Policy */}
        <section className="mb-6">
          <h2 className="text-lg md:text-xl font-semibold text-slate-900 mb-2">
            1. No Return / No Exchange Policy
          </h2>
          <div className="space-y-1 text-sm md:text-base text-slate-700">
            <p>
              We follow a strict <span className="font-semibold">No Return, No Exchange, and No Replacement</span> policy
              for all products.
            </p>
            <p>
              Once an order is placed and delivered, it cannot be returned, exchanged, or replaced under
              any circumstances.
            </p>
            <p>
              Please review your order and product details carefully before completing your purchase.
            </p>
          </div>
        </section>

        {/* 2. Cancellation Policy */}
        <section className="mb-6">
          <h2 className="text-lg md:text-xl font-semibold text-slate-900 mb-2">
            2. Cancellation Policy
          </h2>
          <p className="text-sm md:text-base text-slate-700">
            Orders cannot be cancelled once placed, as processing begins immediately.
          </p>
        </section>

        {/* 3. Refund Policy */}
        <section className="mb-6">
          <h2 className="text-lg md:text-xl font-semibold text-slate-900 mb-2">
            3. Refund Policy
          </h2>
          <p className="text-sm md:text-base text-slate-700 mb-3">
            Refunds are applicable only in the following case:
          </p>

          <h3 className="text-base md:text-lg font-semibold text-slate-900 mb-2">
            A. Duplicate Payment
          </h3>
          <p className="text-sm md:text-base text-slate-700 mb-3">
            If you have accidentally made a duplicate payment, you may request a refund.
          </p>

          <div className="border-l-4 border-emerald-500 bg-emerald-50 px-4 py-3 rounded-md space-y-2">
            <h4 className="text-sm md:text-base font-semibold text-slate-900">
              How to Request a Refund
            </h4>
            <p className="text-sm md:text-base text-slate-700">
              To request a refund, please contact us within <span className="font-semibold">48 hours</span> of
              the transaction.
            </p>
            <p className="text-sm md:text-base text-slate-700">
              Provide the following details:
            </p>
            <ul className="list-disc list-inside text-sm md:text-base text-slate-700 space-y-1">
              <li>Name</li>
              <li>Phone number</li>
              <li>Order ID</li>
              <li>Payment proof</li>
              <li>Reason for refund request</li>
            </ul>
            <p className="text-sm md:text-base text-slate-700">
              📧 Email:{" "}
              <a
                href="mailto:info@tamilsandhai.in"
                className="text-emerald-700 font-medium hover:underline"
              >
                info@tamilsandhai.in
              </a>
            </p>
            <p className="text-xs md:text-sm text-slate-600">
              Refunds are issued only after verification.
            </p>
          </div>
        </section>

        {/* 4. Refund Processing Time */}
        <section className="mb-6">
          <h2 className="text-lg md:text-xl font-semibold text-slate-900 mb-2">
            4. Refund Processing Time
          </h2>
          <div className="space-y-1 text-sm md:text-base text-slate-700">
            <p>
              Once approved, refunds will be credited back to your original payment method within{" "}
              <span className="font-semibold">7–10 working days</span>.
            </p>
            <p>
              Processing time may vary depending on your bank or payment provider.
            </p>
          </div>
        </section>

        {/* Contact Us */}
        <section className="mt-8 border-t pt-5">
          <h2 className="text-lg md:text-xl font-semibold text-slate-900 mb-3">
            Contact Us
          </h2>
          <div className="space-y-1 text-sm md:text-base text-slate-700">
            <p className="font-semibold">TAMILSANDHAI RETAILERS</p>
            <p>H25, OLD ASTC HUDCO,</p>
            <p>THALLY ROAD, HOSUR,</p>
            <p>TAMIL NADU – 635109</p>
            <p className="mt-2">
              📧{" "}
              <a
                href="mailto:info@tamilsandhai.in"
                className="text-emerald-700 font-medium hover:underline"
              >
                info@tamilsandhai.in
              </a>
            </p>
          </div>
        </section>
      </div>
    </div>
  );
};

export default ReturnRefundPolicy;
